import { ServiceUnavailableError, spawnSuccessToast } from "@hm/fundamental"
import { useTraceparent } from "@shared/lib/hooks"
import { CentralizedContainerBox, TraceIdBadge } from "@shared/ui"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"

export const ServiceUnavailablePage: React.FC = () => {
	const [searchParams] = useSearchParams()
	const url = searchParams.get("backUrl")
	const errorMessage = searchParams.get("errorMessage")
	const { traceparent, traceId } = useTraceparent()
	const { t } = useTranslation("pages", { keyPrefix: "serviceUnavailable" })
	const navigate = useNavigate()
	const handleRefresh = () => {
		if (!url) {
			return
		}

		navigate(url)
	}

	const handleCopyErrorLog = () => {
		const decodedErrorMessage = errorMessage ?? ""
		const errorLog = traceparent
			? `${decodedErrorMessage}\n${t("traceparentLabel")}: ${traceparent}`
			: decodedErrorMessage
		navigator.clipboard.writeText(errorLog)
		spawnSuccessToast(t("errorLogCopiedMessage"))
	}

	return (
		<CentralizedContainerBox data-cy="service-unavailable-page-container">
			<div className="flex flex-col items-center">
				<ServiceUnavailableError
					title={t("title")}
					description={t("description")}
					className="!h-auto !pb-6 flex flex-col items-center sm:items-center [&>div:last-child]:justify-center sm:[&>div:last-child]:justify-start"
					refreshText={t("primaryButtonTitle")}
					onRefresh={handleRefresh}
					copyErrorLogText={t("secondaryButtonTitle")}
					onCopyErrorLog={handleCopyErrorLog}
					data-cy="service-unavailable-error"
				/>
				<TraceIdBadge
					traceId={traceId}
					data-cy="service-unavailable-trace-id"
				/>
			</div>
		</CentralizedContainerBox>
	)
}
